import { useEffect, useState } from "react";
import type { Lang } from "../lib/i18n";
import { pick } from "../lib/i18n";
import { getAdminToken, setAdminToken, adminMe } from "../lib/api";
import { exitAdminRoute } from "../lib/state";
import { AdminLogin } from "./AdminLogin";
import { AdminDashboard } from "./AdminDashboard";

/** Admin route (`/admin` or `#admin`): login gate → dashboard. */
export function AdminRoute({ lang }: { lang: Lang }) {
  const t = (ar: string, en: string) => pick(lang, ar, en);
  // "checking" while we validate a stored token against the server.
  const [state, setState] = useState<"checking" | "authed" | "guest">(() => (getAdminToken() ? "checking" : "guest"));

  // Validate a stored token on mount — an expired/invalid one is cleared so the
  // user sees the login screen instead of a silently-broken dashboard.
  useEffect(() => {
    if (state !== "checking") return;
    let cancelled = false;
    adminMe().then((res) => {
      if (cancelled) return;
      if (res.ok) setState("authed");
      else {
        setAdminToken(null);
        setState("guest");
      }
    });
    return () => {
      cancelled = true;
    };
  }, [state]);

  if (state === "checking") {
    return (
      <main className="kd-main">
        <div className="kd-admin-login-wrap" dir={lang === "ar" ? "rtl" : "ltr"}>
          <div className="kd-admin-login-card">
            <p>{t("جارٍ التحقق من الجلسة…", "Checking your session…")}</p>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main className="kd-main">
      {state === "authed" ? (
        <AdminDashboard lang={lang} onExit={exitAdminRoute} onLogout={() => { setAdminToken(null); setState("guest"); }} />
      ) : (
        <AdminLogin lang={lang} onSuccess={() => setState("authed")} onExit={exitAdminRoute} />
      )}
    </main>
  );
}
